import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import { Grid, AccordionSummary, AccordionDetails } from "@material-ui/core";
import Input from "Components/Input/Input";
import Translator from "Languages/Utility/Translator";
import { ExpandMore } from "@material-ui/icons";
import { read } from "Helpers/LocalStorage";
import {
  deleteGoroupUserData,
  getAllGoroupUserData,
  updateGoroupUserData,
} from "Stores/actions";
import showNotify from "Helpers/Notify";
import Accordion from "@material-ui/core/Accordion";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import * as R from "ramda";
import AlertDialog from "Components/AlertDialog/AlertDialog";
import { toggleNPercentRiyal } from "Constants/Constants";
import MuiButton from "Components/MuiButton/MuiButton";
import { useTranslation } from "react-i18next";
import * as Icons from "react-bootstrap-icons";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";

function ExpandUserGroup({ row, expanded, onChangeExpanded }) {
  const { t } = useTranslation();
  const { dataRelationGroupUsers } = useSelector((state) => ({
    dataRelationGroupUsers: state.user.dataRelationGroupUsers,
  }));
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formValid, setFormValid] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [change, setChange] = useState(false);
  const [deleteRelationData, setDeleteRelationData] = useState(null);
  const [controls, setControls] = useSetState({
    name: {
      type: "text",
      value: row.NameGroup,
      validation: {
        required: true,
      },
    },
    profile: {
      type: "price",
      value: row.Profile,
      box: 1,
      validation: {
        required: true,
        isPrice: true,
      },
      relation: "isPercentProfile",
    },
    isPercentProfile: {
      type: "toggle",
      arrayItems: toggleNPercentRiyal,
      relation: "profile",
      value: toggleNPercentRiyal.find((i) => i.value === row.IsPercentProfile),
      validation: {
        required: true,
      },
    },
    fitting: {
      type: "price",
      value: row.Fitting,
      box: 1,
      validation: {
        required: true,
        isPrice: true,
      },
      relation: "isPercentFitting",
    },
    isPercentFitting: {
      type: "toggle",
      arrayItems: toggleNPercentRiyal,
      relation: "fitting",
      value: toggleNPercentRiyal.find((i) => i.value === row.IsPercentFittin),
      validation: {
        required: true,
      },
    },
    glass: {
      type: "price",
      value: row.Glass,
      box: 1,
      validation: {
        required: true,
        isPrice: true,
      },
      relation: "isPercentGlass",
    },
    isPercentGlass: {
      type: "toggle",
      arrayItems: toggleNPercentRiyal,
      relation: "glass",
      value: toggleNPercentRiyal.find((i) => i.value === row.IsPercentGlass),
      validation: {
        required: true,
      },
    },
    net: {
      type: "price",
      value: row.Net,
      box: 1,
      validation: {
        required: true,
        isPrice: true,
      },
      relation: "isPercentNet",
    },
    isPercentNet: {
      type: "toggle",
      arrayItems: toggleNPercentRiyal,
      relation: "net",
      value: toggleNPercentRiyal.find((i) => i.value === row.IsPercentNet),
      validation: {
        required: true,
      },
    },
    other: {
      type: "price",
      value: row.Other,
      box: 1,
      validation: {
        required: true,
        isPrice: true,
      },
      relation: "isPercentOther",
    },
    isPercentOther: {
      type: "toggle",
      arrayItems: toggleNPercentRiyal,
      relation: "other",
      value: toggleNPercentRiyal.find((i) => i.value === row.IsPercentOther),
      validation: {
        required: true,
      },
    },
    service: {
      type: "price",
      value: row.Service,
      box: 1,
      validation: {
        required: true,
        isPrice: true,
      },
      relation: "isPercentService",
    },
    isPercentService: {
      type: "toggle",
      arrayItems: toggleNPercentRiyal,
      relation: "service",
      value: toggleNPercentRiyal.find((i) => i.value === row.IsPercentService),
      validation: {
        required: true,
      },
    },
  });

  useEffect(() => {
    setChange(false);
  }, []);

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
    setChange(true);
  };

  const onChangeToggle = (name, key, value) => {
    setControls({ [name]: { value: value } });
    setControls({ [controls[name].relation]: { value: 0 } });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const {
      name,
      profile,
      fitting,
      glass,
      net,
      other,
      service,
      isPercentProfile,
      isPercentFitting,
      isPercentGlass,
      isPercentNet,
      isPercentOther,
      isPercentService,
    } = controls;

    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      try {
        setLoading(true);
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Id: row.Id,
          IsPercentNet: isPercentNet.value.value,
          IsPercentOther: isPercentOther.value.value,
          Fitting: convertToEnglishNumber(fitting.value),
          IsPercentService: isPercentService.value.value,
          Glass: convertToEnglishNumber(glass.value),
          Service: convertToEnglishNumber(service.value),
          IsPercentProfile: isPercentProfile.value.value,
          Profile: convertToEnglishNumber(profile.value),
          Name: name.value,
          IsPercentGlass: isPercentGlass.value.value,
          IsPercentFittin: isPercentFitting.value.value,
          Net: convertToEnglishNumber(net.value),
          Other: convertToEnglishNumber(other.value),
        };
        await dispatch(updateGoroupUserData(data));
        const params = { KeyGroup: read("groupKey"), KeyUser: read("userKey") };
        await dispatch(getAllGoroupUserData(params));
        setLoading(false);
      } catch (e) {
        showNotify({
          text: t("correctFormDataRequired"),
          customClass: "error",
        });
        setLoading(false);
      }
    } else {
      showNotify({
        text: t("correctFormDataRequired"),
        customClass: "error",
      });
    }
  };

  const onShowAlert = () => {
    setShowAlert(!showAlert);
    setDeleteRelationData(null);
  };

  const onDelete = async () => {
    try {
      setLoading(true);
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Id: row.Id,
      };
      await dispatch(deleteGoroupUserData(data));
      setLoading(false);
    } catch (err) {
      console.error("[catch error]", err);
    }
  };

  useEffect(() => {
    setDeleteRelationData(dataRelationGroupUsers);
  }, [dataRelationGroupUsers]);

  const onChangeAccordion = () => {
    if (expanded !== row.Id) onChangeExpanded(row.Id);
    else onChangeExpanded(-1);
  };

  return (
    <Accordion
      variant="outlined"
      className="overflow-hidden cu-group"
      // expanded={expanded === row.Id}
      // onChange={onChangeAccordion}
    >
      <AccordionSummary expandIcon={<ExpandMore />} className="bg-action">
        <div className="w-100 d-flex align-items-center overflow-hidden g-1">
          <div>{row.NameGroup}</div>
        </div>
        <div>
          <MuiIconButton
            icon={<Icons.Trash3 size={17} />}
            className="danger-fill"
            onClick={onShowAlert}
          />
          <AlertDialog
            showAlert={showAlert}
            type="alertError"
            onClose={onShowAlert}
            onClickOk={onDelete}
            okTitle={<Translator id="ble_pak_shavad" />}
            cancelTitle={<Translator id="enseraf" />}
            questionText={<Translator id="aya_az_hazf_an_etminan_darid" />}
            relationText={<Translator id="relationAlert" />}
            relationData={deleteRelationData}
            loading={loading}
          />
        </div>
      </AccordionSummary>
      <AccordionDetails className={"details"}>
        <Grid container spacing={2}>
          <Grid item xs={12} className="px-0 mt-4">
            <Input
              setValue={setValue.bind(this)}
              name="name"
              validation={controls.name.validation}
              label={<Translator id="name_groh_jadid" />}
              type="text"
              value={controls.name.value}
            />
          </Grid>
          {Object.keys(controls)
            .filter((key) => controls[key].box === 1)
            .map((key, index) => {
              return (
                <Grid item xs={12}>
                  <Input
                    setValue={setValue.bind(this)}
                    value={controls[key].value}
                    name={key}
                    placeholder={t(key)}
                    validation={controls[key].validation}
                    label={<Translator id={key} />}
                    type={controls[key].type}
                    endIcon={
                      controls[controls[key].relation].value.value ? (
                        "%"
                      ) : (
                        <Translator id={"moneyUnit"} />
                      )
                    }
                    radioGroup={{
                      name: controls[key].relation,
                      value: controls[controls[key].relation].value,
                      items: controls[controls[key].relation].arrayItems,
                      onChange: onChangeToggle,
                    }}
                  />
                </Grid>
              );
            })}
          <Grid item xs={12} className="mt-3">
            <MuiButton
              loading={loading}
              color="primary"
              title={<Translator id="virayesh" />}
              onClick={onSubmit}
              className="w-100"
              disabled={!change}
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}

export default ExpandUserGroup;
